import { loading, success, handleErrorException } from 'State/actions';
import { isRequestCancelation } from 'Common/Helpers';

import { PagingFilterTypeEnum } from 'Common/Constants/Enumeration/PagingFilterTypeEnum';

import * as types from './types';
import { commonStatePagingSelectors } from './selectors';
import * as constants from './constants';
import {
  convertGridFilterToFilter,
  convertGridSortToSortColumn,
} from './helpers';

export const commonStatePagingActions = (prefix) => {
  const selectors = commonStatePagingSelectors(
    prefix === constants.primaryPrefix
      ? constants.primaryStateName
      : constants.secondaryStateName
  );
  return {
    getPage: (resource, data) => async (dispatch, getState, MPWWebApi) => {
      try {
        const state = getState();
        const pagingParameters = selectors.getPaginationParameters(state);

        const dataWithPagingParameters = {
          ...data,
          ...pagingParameters,
        };

        const { source, Api } = MPWWebApi.createCancelableApi();

        dispatch(
          loading(types[`${prefix}PAGING_FETCHING`], true, true, source)
        );

        const response = await Api.postGenericInsertUpdate(
          resource,
          dataWithPagingParameters
        );
        const pageResult = response.data.Data;
        dispatch(success(types[`${prefix}PAGING_SUCCESS`], pageResult));
        dispatch(loading(types[`${prefix}PAGING_FETCHING`], false));
      } catch (ex) {
        const defaultError = {
          Title: 'Error',
          Message: 'An error occurred while retrieving the data.',
        };
        dispatch(
          handleErrorException(ex, types[`${prefix}PAGING_ERROR`], defaultError)
        );
        if (!isRequestCancelation(ex)) {
          dispatch(loading(types[`${prefix}PAGING_FETCHING`], false));
        }
      }
    },

    reset: () => ({
      type: types[`${prefix}PAGING_RESET`],
    }),

    setPageSize: (pageSize, pageNumber) => ({
      type: types[`${prefix}PAGING_SET_PAGE_SIZE`],
      payload: { pageSize, pageNumber },
    }),

    setPageNumber: (pageNumber) => ({
      type: types[`${prefix}PAGING_SET_PAGE_NUMBER`],
      payload: pageNumber,
    }),

    setFilter: (filtered, filterType = PagingFilterTypeEnum.Contains) => {
      const filter = convertGridFilterToFilter(filtered, filterType);
      return {
        type: types[`${prefix}PAGING_SET_FILTER`],
        payload: filter,
      };
    },

    setSortColumn: (sorted) => {
      const sortColumn = convertGridSortToSortColumn(sorted);
      return {
        type: types[`${prefix}PAGING_SET_SORT_COLUMN`],
        payload: sortColumn,
      };
    },

    setSearchParameters: (parameters) => ({
      type: types[`${prefix}PAGING_SET_SEARCH_PARAMETERS`],
      payload: parameters,
    }),
  };
};



// WEBPACK FOOTER //
// ./src/state/paging/actions.js